import { all, put, takeLatest, select, call } from 'redux-saga/effects';
import { changeWorkSpace } from '../routines/workspaceRoutines';
import { initialization, fetchCurrentUser } from '../routines';
import getStorage, { LOCAL_STORAGE } from '../../common/util/StorageHelper';
import { CURRENT_WORK_SPACE } from '../../common/constants/UserManagementConstants';
import envConfig from '../../config';
import { request } from '../../common/util/RestClient';
import { GET_USER_LOGIN_DATA } from '../../common/GoogleTagManager/GoogleTagManager';

export function* changeWorkSpaceSaga({ payload }) {
  try {
    const { workSpace, reload } = payload;
    const storage = getStorage(LOCAL_STORAGE);
    storage.setItem(CURRENT_WORK_SPACE, JSON.stringify(workSpace));
    const username = yield select((state) => state.auth.username);

    // Step 1 : get user details for selected workspace
    const url = `${
      envConfig.APIG_URL
    }user-management/users?username=${encodeURIComponent(username)}`;
    const userDetails = yield call(request, url, null);
    yield put(fetchCurrentUser.success({ user: userDetails.data.users[0] }));

    // Step 2 : get tenant details for selected workspace (tenant)
    const URL = `${envConfig.APIG_URL}tenant-information/tenants/${workSpace.tenantId}`;
    const response = yield call(request, URL, null);
    const { data } = response;
    const gtmPayload = { ...data, username };
    GET_USER_LOGIN_DATA(gtmPayload, 'workspaceSaga');

    // Step 3 : reload the initial application data for new workspace
    if (reload) {
      yield put(initialization.trigger());
    }
    // Step 4 : updated the application state with new workspace
    yield put(changeWorkSpace.success(workSpace));
  } catch (error) {
    yield put(changeWorkSpace.failure({ error }));
  }
}

export default function* root() {
  yield all([takeLatest(changeWorkSpace.TRIGGER, changeWorkSpaceSaga)]);
}
